import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { SezioneLettereDiffidaFull } from '../../../models/sezioni/sezione-lettere-diffida-full';
import { LettereDiffidaAddComponent } from './lettere-diffida-add.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [lettere-diffida-add]',
  templateUrl: 'lettere-diffida-add-mod.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class LettereDiffidaAddMod {
  @Output() onReturn: EventEmitter<SezioneLettereDiffidaFull> = new EventEmitter<SezioneLettereDiffidaFull>();
  @ViewChild('formAdd') formAdd: LettereDiffidaAddComponent;

  inizializza(urlAddLetteraDiffida: string, idSezione: string, idFascicolo: string,
              urlReadSezioneControparti: string, idSezioneControparti: string
  ) {
    this.formAdd.inizializza(urlAddLetteraDiffida, idSezione, idFascicolo, urlReadSezioneControparti, idSezioneControparti);
    openModal('modaladd');
  }

  createForm() {
    this.formAdd.createForm();
  }

  manageModal(sezione: SezioneLettereDiffidaFull) {
      closeModal('modaladd');
      this.onReturn.emit(sezione);
  }
}
